import { Directive, Input, forwardRef, OnInit } from '@angular/core';
import { NG_VALIDATORS, Validator, ValidatorFn, AbstractControl } from '@angular/forms';

import { PhoneValidators } from './phone-validators';



export class PossiblePhoneValidatorDirective implements Validator, OnInit {
     possiblePhone: string = 'US';

    private validator: ValidatorFn;

    ngOnInit() {
        this.validator = PhoneValidators.isPossibleNumberWithReason(this.possiblePhone);
    }

    validate(c: AbstractControl): { [key: string]: any } {
        return this.validator(c);
    }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
    selector: '[possiblePhone][formControlName],[possiblePhone][formControl],[possiblePhone][ngModel]',
    providers: [{
        provide: NG_VALIDATORS,
        // tslint:disable-next-line:no-forward-ref
        useExisting: forwardRef(() => PossiblePhoneValidatorDirective),
        multi: true
    }]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'possiblePhone': [{ type: Input },],
};
}



export class PhoneValidatorDirective implements Validator, OnInit {
     phone: string = 'US';

    private validator: ValidatorFn;

    ngOnInit() {
        this.validator = PhoneValidators.isPhoneNumber(this.phone);
    }

    validate(c: AbstractControl): { [key: string]: any } {
        return this.validator(c);
    }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
    selector: '[phone][formControlName],[phone][formControl],[phone][ngModel]',
    providers: [{
        provide: NG_VALIDATORS,
        // tslint:disable-next-line:no-forward-ref
        useExisting: forwardRef(() => PhoneValidatorDirective),
        multi: true
    }]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'phone': [{ type: Input },],
};
}



export class CountryCodeValidatorDirective implements Validator, OnInit {

    private validator: ValidatorFn;

    ngOnInit() {
        this.validator = PhoneValidators.isValidRegionCode;
    }

    validate(c: AbstractControl): { [key: string]: any } {
        return this.validator(c);
    }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
    selector: '[countryCode][formControlName],[countryCode][formControl],[countryCode][ngModel]',
    providers: [{
        provide: NG_VALIDATORS,
        // tslint:disable-next-line:no-forward-ref
        useExisting: forwardRef(() => CountryCodeValidatorDirective),
        multi: true
    }]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
